// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/content-documents/shared/source-avatar/source-avatar.component.scss
// module id = 185
// module chunks = 0